/**
 * Which league sections the All feed renders, and in what order.
 */
import type { typeCatalogSportInput } from "./leagueSelectorRowModel";

export type typeScoresHomeSection = {
  leagueId: string;
  leagueName: string;
  isPinned: boolean;
};

/** Which league sections the All feed renders, and in what order.
 *  Q277 point 3: the fan's pinned leagues first, in pin order, then every
 *  other league that has a game in the window, in catalog order. */
export function resolveScoresHomeSections(input: {
  sports: typeCatalogSportInput[];
  pinnedLeagueIds: string[];
  /** League ids that came back with at least one event from
   *  /feed/upcoming. */
  leagueIdsWithGames: readonly string[];
}): typeScoresHomeSection[] {
  const nameByLeagueId = new Map<string, string>();
  for (const sport of input.sports) {
    for (const league of sport.leagues) {
      nameByLeagueId.set(league.leagueId, league.shortName);
    }
  }

  const emitted = new Set<string>();
  const sections: typeScoresHomeSection[] = [];

  for (const leagueId of input.pinnedLeagueIds) {
    const leagueName = nameByLeagueId.get(leagueId);
    if (leagueName === undefined) continue;
    sections.push({ leagueId, leagueName, isPinned: true });
    emitted.add(leagueId);
  }

  const gamesLeagueIds = new Set(input.leagueIdsWithGames);
  for (const sport of input.sports) {
    for (const league of sport.leagues) {
      if (emitted.has(league.leagueId)) continue;
      if (!gamesLeagueIds.has(league.leagueId)) continue;
      sections.push({
        leagueId: league.leagueId,
        leagueName: league.shortName,
        isPinned: false,
      });
      emitted.add(league.leagueId);
    }
  }

  return sections;
}
